<div class="white m-t-md round-content ch-grey">
  <div class="p-a">
    <p class="m-b-0 _700 text-md ">
      <span>{{'NUMBERS.RECORDING' | translate}}</span>
      <mat-icon
        class="text-xs gray-text pointer "
        [matTooltip]="'NUMBERS.RECORDING_TOOLTIP' | translate">help_outline
      </mat-icon>
      <ui-switch class="pull-right custom m-t-2px " [checked]="isRecordingEnabled"
                 [disabled]="!isRecordingPossible()"
                 [matTooltip]="recordingDisabledTooltip() | translate"
                 (change)="onRecordingEnabledChange($event)"></ui-switch>
    </p>
  </div>
</div>
